import { createAsyncThunk } from '@reduxjs/toolkit';
import { toastr } from 'react-redux-toastr';

import { Basket } from '../../Modules/Basket';
import { AuthService } from '../../service/auth/auth.service';
import { UserService } from '../../service/user/user.service';
import { getErrorMessage } from '../../utils/get-error-message';
import { setStoreLocal } from '../../utils/local-storage';
import { toastrError } from '../../utils/toastr-error';

import { IAuthResponseData, IEmailPassword, IRegister } from './user.interface';
import { userActions } from './user.slice';
import {saveTokensStorage, removeTokensStorage} from '../../service/auth/auth.helps';
import { Util } from '../../common/util/util';

export const register = createAsyncThunk<IAuthResponseData, IRegister>(
  'auth/register',
  async ({ phone_or_email, action }, { rejectWithValue }) => {
    try {
      const response = await AuthService.register(phone_or_email, action);
      if (response.data.error) {
        getErrorMessage('Авторизация', Number(response.data.error_code));
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      toastrError(error);
      return rejectWithValue(error);
    }
  }
);

export const login = createAsyncThunk<IAuthResponseData, IEmailPassword>(
  'auth/login',
  async (
    { phone_or_email, password, is_one_time_password },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await AuthService.login(
        phone_or_email,
        password,
        is_one_time_password
      );
      if (response.data.error) {
        getErrorMessage('Авторизация', Number(response.data.error_code));
        return rejectWithValue(response.data.error);
      } else toastr.success('Авторизация', 'Завершено успешно');
      if (!response.data.phone) {
        return rejectWithValue(response.data.error);
      }

      dispatch(userActions.setSessionToken(response.data['session-token']));
      dispatch(userActions.setPhoneOrEmail(phone_or_email));
      dispatch(userActions.setUser(
        {
          email: response.data.email,
          error: response.data.error,
          error_code: response.data.error_code,
          message: response.data.message,
          phone: response.data.phone,
          super_admin: response.data.super_admin,
          user_has_permanent_password: response.data.user_has_permanent_password,
          valid: true
        }
      ));
      dispatch(userActions.setLoggedIn(true));
      dispatch(userActions.setSuperAdmin(response.data.super_admin));
      
      saveTokensStorage(response.data['session-token'] as string);
      localStorage.setItem("pe", phone_or_email);
      localStorage.setItem("p", response.data.phone);
      localStorage.setItem("e", response.data.email);

      //Сохраняем также на другой домен:
      Util.crossDomainLocalStorageSetItem("st", response.data["session-token"] as string);
      Util.crossDomainLocalStorageSetItem("pe", phone_or_email);
      Util.crossDomainLocalStorageSetItem("p", response.data.phone);
      Util.crossDomainLocalStorageSetItem("e", response.data.email);

      await Basket.basketLoadLocal(dispatch);
      await Basket.basketSynchronization(dispatch);
      
      dispatch(getProfile());
      
      return response.data;
    } catch (error) {
      toastrError(error);
      return rejectWithValue(error);
    }
  }
);

//logout
export const logout = createAsyncThunk('auth/logout', async () => {
  await AuthService.logout();
  removeTokensStorage()
});

//Проверка сессии пользователя
export const checkAuth = createAsyncThunk<IAuthResponseData>(
  'auth/check-login',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.checkLogin();
      
      if(response.data.error || !response.data.valid){
        return rejectWithValue(response.data.error);
      }
      
      dispatch(userActions.setLoggedIn(response.data.valid));
      dispatch(userActions.setSuperAdmin(response.data.super_admin));
      
      await Basket.basketLoadLocal(dispatch);
      await Basket.basketSynchronization(dispatch);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProfile = createAsyncThunk(
  'user/get-profile',
  async (_, { rejectWithValue }) => {
    try {
      let token = localStorage.getItem("st");
      if(token != null){
        const data = await UserService.getProfile();
        if (!data?.error) {
          //Удалим секретную информацию
          delete data.profile.docs;
          delete data.profile.confirm_email;
          delete data.profile.confirm_phone;
          delete data.profile.id;

          setStoreLocal('profile', data.profile);
        }
        return data.profile;
      }else{
        rejectWithValue("Пользователь не авторизован")
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//Проверка сессии пользователя, затем получения профиля
export const checkAuthAndGetprofile = createAsyncThunk<IAuthResponseData>(
  'auth/check-login-get-profile',
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as any;
      
      let getProfile: boolean = false;
      let profile_data = null;

      if(!state.user.loggedIn){
        //Проверка сессии пользователя
        const response = await AuthService.checkLogin();

        if (response.data.valid){
          dispatch(userActions.setLoggedIn(response.data.valid));
          dispatch(userActions.setSuperAdmin(response.data.super_admin));

          getProfile = true;
          //Синхронизация корзины
          await Basket.basketLoadLocal(dispatch);
          await Basket.basketSynchronization(dispatch);
          
        }else{
          return rejectWithValue(response.data.error);
        }
      }else{
        getProfile = true;
      }

      if(getProfile){
        //Получаем профиль
        profile_data = await UserService.getProfile();
        if (!profile_data?.error) {
          //Удалим секретную информацию
          delete profile_data.profile.docs;
          delete profile_data.profile.confirm_email;
          delete profile_data.profile.confirm_phone;
          delete profile_data.profile.id;

          setStoreLocal('profile', profile_data.profile);

          dispatch(userActions.setProfile(profile_data.profile));

        }else{
          rejectWithValue("Пользователь не авторизован")
        }
      }
      
      return profile_data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
